define('app/factories/search_results_factory',['app/setup', 'app/views/search_results_view'],
  function(takhfifan, searchResultsView) {
    var $window = new takhfifan.WindowView({
      el: $(window)
    });

    $('.tkh-search-results').each(function(){
      new takhfifan.SearchResultsView({
        el: $(this),
        window: $window
      });
    });
});

